import * as React from "react";

import "./cc-component.scss";

import {cs}                        from "@Common/react/chain-services";
import {consumeContext}            from "@Common/react/context";
import {fragments}                 from "@Common/react/fragments";
import {Invoke}                    from "@Common/react/invoke";
import {QueryString}               from "@Common/react/query-string";
import {Watch}                     from "@Common/react/watch";
import {getMergeFieldErrorMessage} from "@Common/tools/cc-integration/get-merge-field-error-message";
import {CheckExhibitProducts}      from "@Common/tools/cc-integration/ui/check-exhibit-products";

export const CcComponent = ({exhibit, templateOptions, distributionType, itemId, next}) => cs(
    consumeContext("apis"),
    ["checkExhibitProducts", (_, next) => CheckExhibitProducts({next})],

    ({}, next) => fragments(
        next(),

        syncSideIndex({exhibit}),
    ),

    ({apis, checkExhibitProducts}) => next({
        renderControls: ({className}) => <>
            <div className={className}>
                {exhibit.controls}
            </div>
        </>,
        renderForm: () => exhibit.editForm,

        renderLoading: () => !exhibit.initialized && (
            <div className="cc-component-8jz loading">
                <div className="overlay" />

                <img className="loadingImage" {...{
                    src: exhibit.proofImages?.[0] ?? "assets/SPINNER.svg",
                }}/>

                {exhibit.proofImages?.[0] && !advEditMode ? (
                    <button
                        className="retry"
                        onClick={()=>window.location.reload()}
                        xd-qa-type="button"
                        xd-qa-name="Retry"
                    >Retry</button>
                ) : exhibit.proofImages?.[0] == "assets/SPINNER_ERROR_STATE_FAILED.svg" && (
                    <button
                        className="retry"
                        onClick={()=>refreshTemplateModal.show()}
                        xd-qa-type="button"
                        xd-qa-name="Refresh Template"
                    >
                        Refresh Template
                    </button>
                )}
            </div>
        ),

        editor: {
            changed: exhibit.changed,
            loading: !exhibit.initialized,
            hasRequiredError: exhibit.isRequired,

            getErrorMessages: async () => {
                if (templateOptions.allowVariableData && distributionType === "mailing") {

                    // const mergeFieldErrorMessage = await exhibit.getMergeFieldErrorMessageJsx();
                    const mergeFieldErrorMessage = await getMergeFieldErrorMessage({
                        ccEditor: exhibit.cc.ccEditor,
                        apis,
                        templateOptions,
                    });

                    if (mergeFieldErrorMessage) {
                        return [mergeFieldErrorMessage];
                    }
                }
                return [];
            },

            save: async ({final}) => {
                await exhibit.save();

                if (final) {
                    await checkExhibitProducts({
                        urlsToCheck: true,
                        ccStateId: exhibit.ccStateId,
                        itemId,
                    });
                }

                return true;
            },
        },
    })
);

const syncSideIndex = ({exhibit}) => cs(
    ["side", ({}, next) => QueryString({
        param: "side",
        next: ({value, onChange}) => next({value: value == null ? 0 : +value, onChange}),
    })],
    ({side}) => exhibit.currentSideIndex != null && <>

        {Invoke({
            fn: () => {
                if (exhibit.currentSideIndex != side.value) {
                    exhibit.changeSide(+side.value);
                }
            },
        })}

        {Watch({
            value: exhibit.currentSideIndex,
            onChanged: side.onChange,
        })}

    </>,
);

